import React from "react";
import { useNavigate } from "react-router-dom";
import "./Successpage.css";

export default function Successpage() {
    const navigate = useNavigate();
    return (
        <div className="success-main">
            <div className="content">
                <img src="./assets/images/icon-success.svg" alt="Success Icon"/>
                <h2>Thanks for subscribing!</h2>
                <p>A confirmation email has been sent to <strong>ash@yopmail.com</strong>. Please open it and click the button inside to confirm your subscription.</p>
                <div className="button-section">
                    <button onClick={() => { navigate(-1) }}>Dismiss message</button>
                </div>
            </div>
        </div>
    )
}